import { call, put } from 'redux-saga/effects';

import { fetchJurisdictions } from '@api/jurisdictions';
import { getJurisdictionsListModel } from '@models/jurisdictions';
import { jurisdictionsSuccess } from '@store/jurisdictions';

export const fetchJurisdictionsSaga = function* ({ payload }) {
  const { limit, offset } = payload;
  const response = yield call(fetchJurisdictions, { limit, offset });
  const model = yield call(getJurisdictionsListModel, response.results);
  yield put(jurisdictionsSuccess(model));
};
